/** Peças do painel usadas também nos relatórios: quadro de status que filtra, etiqueta de filtro e painel com título. */
import type { ReactNode } from 'react';
import clsx from 'clsx';
import type { DashboardStatus } from '@pmis/shared';
import { Icon, STATUS_VAR, StatusGlyph } from './pmis';

export function StatusTile({ status, label, value, total, selected, onClick, showShare = true }: {
  status: DashboardStatus; label: string; value: number; total: number; selected: boolean; onClick: () => void; showShare?: boolean;
}) {
  const share = total ? Math.round((value / total) * 100) : 0;
  return (
    <button type="button" onClick={onClick} aria-pressed={selected}
      className={clsx('group relative overflow-hidden rounded-2xl border bg-panel p-4 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md',
        selected ? 'border-transparent ring-2 ring-accent' : 'border-line', value === 0 && !selected && 'opacity-70')}>
      <span aria-hidden className="absolute inset-x-0 top-0 h-1" style={{ background: STATUS_VAR[status] }} />
      <div className="flex items-center justify-between">
        <span className="grid size-8 place-items-center rounded-xl" style={{ background: `color-mix(in srgb, ${STATUS_VAR[status]} 18%, transparent)` }}><StatusGlyph status={status} className="size-4" /></span>
        {showShare ? <span className="num text-[11px] font-medium text-muted">{share}%</span> : null}
      </div>
      <div className="mt-3 text-3xl font-semibold leading-none">{value}</div>
      <div className="mt-1.5 text-xs font-medium text-muted group-hover:text-fg">{label}</div>
    </button>
  );
}

export function SelChip({ label, onClear }: { label: string; onClear: () => void }) {
  return <button type="button" onClick={onClear} className="inline-flex items-center gap-1 rounded-full border border-accent/40 bg-accent/10 px-2.5 py-0.5 text-xs hover:bg-accent/20">{label}<Icon name="x" className="size-3" /></button>;
}

export function Panel({ title, sub, children }: { title: string; sub?: string; children: ReactNode }) {
  return (
    <section className="rounded-2xl border border-line bg-panel p-5 shadow-sm">
      <h3 className="text-sm font-semibold">{title}</h3>
      {sub ? <p className="mb-4 mt-0.5 text-[11px] text-muted">{sub}</p> : <div className="mb-4" />}
      {children}
    </section>
  );
}
